/**
 * @fileoverview This file contains functions to handle tooltip toggling, closing tooltips,
 * and scrolling to the next fieldset in a form. It also initializes event listeners for
 * these functionalities.
 */

const openTooltipButton = [...document.querySelectorAll('.connections-form__tooltip-open-button')];
const closeTooltipButton = [
  ...document.querySelectorAll('.connections-form__tooltip-close-button'),
];

/**
 * Toggles the display of the tooltip.
 * @param {Event} event - The event object.
 */
function toggleTooltip(event) {
  event.preventDefault();
  let elementDisplayValue = event.target.closest('.connections-form__title-wrapper')
    .nextElementSibling.style.display;

  if (elementDisplayValue === 'flex') {
    event.target.closest('.connections-form__title-wrapper').nextElementSibling.style.display =
      'none';
    return;
  }

  event.target.closest('.connections-form__title-wrapper').nextElementSibling.style.display =
    'flex';
}

/**
 * Closes the tooltip.
 * @param {Event} event - The event object.
 */
function closeTooltip(event) {
  event.preventDefault();
  event.target.closest('.connections-form__tooltip').style.display = 'none';
}


/**
 * Initializes event listeners for tooltip buttons and radio buttons.
 */
function init() {
  if (!openTooltipButton.length) {
    return;
  }

  openTooltipButton.forEach((button) => {
    button.addEventListener('click', toggleTooltip);
    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        toggleTooltip(event);
      }
    });
  });

  if (!closeTooltipButton.length) {
    return;
  }

  closeTooltipButton.forEach((button) => {
    button.addEventListener('click', closeTooltip);
    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') {
        closeTooltip(event);
      }
    });
  });
}

export default init;
